<template>
	<div class="pull-dialog-body">
		<div class="pull-container">
			<div class="middle-part">
				<div class="main-part">
					<div class="query-part">
						<span>类别名称：</span>
						<el-input size="mini" v-model="class_name" placeholder="请输入类别名称"></el-input>
						<span>商品编码：</span>
						<el-input size="mini" v-model="goods_no" placeholder="请输入商品编码"></el-input>
						<span>查询时间：</span>
						<el-date-picker
							v-model="dateValue"
							size="mini"
							:unlink-panels='true'
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							format='yyyy-MM-dd'
							value-format='yyyy-MM-dd'>
						</el-date-picker>
						<el-button size="small" type="primary" plain class="btn" @click="searchClick">查询</el-button>
					</div>
					<div class="line"></div>
					<div class="select-part">
						<span>设置商品平台品类：</span>
						<el-select v-model="bcId" class="filter-input" size='mini' @change="bcChange">
							<el-option value="0" label="全部"></el-option>
							<template v-for="(item) in bc">
								<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
							</template>
						</el-select>
						<el-select v-model="scId" class="filter-input" size='mini'>
							<el-option value="0" label="全部"></el-option>
							<template v-for="(item) in sc">
								<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
							</template>
						</el-select>
					</div>
					<div class="main-table">
						<div class="main-table-box">
							<el-table
								size='mini'
								class="grid-content"
								:data="refreshData"
								border
								stripe
								:height="tableHeight"
								@selection-change="selectionChangeHandle"
							>
								<el-table-column
									type="selection"
									align="center"
									width="55">
								</el-table-column>
								<el-table-column
									prop="goods_name"
									label="品项名称"
									align="center"
									min-width="180">
								</el-table-column>
								<el-table-column
									prop="goods_no"
									label="品项编号"
									align="center"
									min-width="180">
								</el-table-column>
								<el-table-column
									prop="spec_name"
									label="品项单位"
									align="center"
									min-width="180">
								</el-table-column>
							</el-table>
						</div>
					</div>
					<el-pagination
						@current-change="handleCurrentChange"
						:page-size="100"
						layout="prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<div class="btn-box">
			<el-button class="btn" plain type="primary" @click="close">取消</el-button>
			<el-button class="btn" plain type="primary" @click="save">保 存</el-button>
		</div>
		<span @click="close" class="close"><i class="el-icon-close"/></span>
	</div>
</template>
<script>
export default {
	name: 'pullDialog',
	props: {
		classData: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			page_no: 1,
			total: null,
			dateValue: [],
			enableFlag: -1,
			class_name: '',
			goods_no: '',
			bcId: '0',
			scId: '0',
			bc: [],
			sc: [],
			tableHeight: '100%',
			selectedArr: [],
			refreshData: []
		}
	},
	created () {
		this.getBaseCategory()
		var now = new Date()
		this.dateValue = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.setDate(now)]
		this.refresh()
	},
	methods: {
		searchClick () {
			this.page_no = 1
			this.refresh()
		},
		handleCurrentChange (val) {
			this.page_no = val
			this.refresh()
		},
		getBaseCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		refresh () {
			var now = new Date()
			var endTime = new Date(this.dateValue[1] + ' 23:59:59')
			var min = now.getMinutes() > 9 ? now.getMinutes() : '0' + now.getMinutes()
			let time = this.dateValue[1] + ' ' + now.getHours() + ':' + min + ':00'
			let params = {
				page_size: 100,
				page_no: this.page_no - 1,
				class_name: this.class_name,
				goods_no: this.goods_no,
				start_time: this.dateValue[0] + ' 00:00:00',
				end_time: endTime > now ? time : this.dateValue[1] + ' 23:59:59'
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/match/getWDTGoodsInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.refreshData = res.data
					if (params.page_no === 0) {
						this.total = res.totalCnt
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		bcChange () {
			this.sc = []
			if (this.bcId === '0') {
				this.scId = '0'
				return false
			}
			this.getSmallCategory()
		},
		getSmallCategory () {
			var params = {
				pid: this.bcId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		selectionChangeHandle (data) {
			this.selectedArr = data
		},
		save () {
			if (this.bcId === '0' || this.scId === '0') {
				this.$message.error('请选择平台商品品类')
				return false
			}
			if (this.selectedArr.length < 1) {
				this.$message.error('请至少选择一个商品！')
				return false
			}
			this.savePost()
		},
		savePost () {
			let params = {
				bcId: this.bcId,
				scId: this.scId,
				itemList: this.selectedArr
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/match/saveWDTGoodsInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.refresh()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(() => {
				this.$message.error('导入失败，请重试！')
			})
		},
		cancel () {
			this.dialogVisible = false
		},
		close () {
			this.$emit('update:visible', false)
			this.$emit('refresh')
		}
	}
}
</script>

<style lang="stylus" scoped>
.pull-dialog-body {
	display flex
	flex: 1
	flex-direction column
	height: 650px;
	padding-top: 10px;
	.pull-container {
		display flex
		flex: 1
		height: 100%;
		.left-part {
			width: 180px;
			display flex;
			flex-direction column
			.title {
				text-align left
				border-left 5px solid var(--fx-primary-color)
				padding-left 10px
				line-height 28px;
				height: 28px;
				font-size 18px;
				margin-bottom 20px;
			}
			.el-tree {
				flex: 1
				overflow auto
			}
		}
		.middle-part {
			display flex;
			height: 100%;
			flex: 1
			flex-direction column
			.header-part {
				height: 28px;
				line-height 28px;
				font-size 16px;
				text-align left;
				span {
					color: #CBCBCB;
					margin-right: 50px;
				}
				.product-name {
					display: inline-block;
					width: 140px;
				}
				.el-input {
					width: 200px;
					margin-right 5px;
				}
				.status-input {
					margin-right: 10px;
				}
				i {
					font-size 20px;
					cursor pointer
				}
			}
			.main-part {
				display flex
				flex-direction column
				flex: 1
				height: 100%
				padding-top: 10px;
				padding-right: 30px;
				.query-part {
					display flex
					height: 28px;
					line-height 28px;
					margin-bottom 10px;
					font-size: 16px;
					.el-input {
						margin-right: 10px;
						width: 180px;
					}

					.btn {
						margin-left :10px;
						line-height: 8px;
					}
				}
				.line {
					height: 1px;
					background: #eee;
					margin-bottom: 10px;
				}
				.select-part {
					display flex
					width: 500px
					height: 28px;
					line-height 28px;
					margin-bottom 10px;
					font-size: 16px;
					span {
						margin-right: 10px
					}
					.filter-input {
						flex: 1;
						margin-right: 10px;
					}
				}
				.fx-big-btn {
					margin 0 0 10px 0
				}
				.main-table {
					display flex
					flex: 1
					height: 100%;
					flex-direction: column
					.main-table-box {
						flex: 1
						padding-bottom 10px
						overflow-y: auto;
					}
				}
			}
		}
	}
	.btn-box {
		margin-top 15px;
		height: 40px;
		.el-button {
			width: 200px;
		}
	}
	.close {
		position absolute
		right: 20px;
		top: 20px;
		cursor pointer
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background-color: red;
		line-height: 21px;
		font-weight: bold;
		.el-icon-close{
			color:#fff
		}
	}
}
</style>
<style lang="stylus">
.confirm-dialog {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
	}
	.el-dialog__headerbtn{
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background-color: red;
		line-height: 20px;
		font-weight:blod;
		.el-icon-close{
			color:#fff
		}
	}
	.confirm-info {
		margin-top 10px
		width: 100%;
		height: 200px;
		border: 1px solid #ECECEC
		line-height 30px
		overflow-y auto
		.info-item {
			height: 30px
			border-bottom: 1px solid #ECECEC
			span {
				display inline-block
				width: 50%
				height: 100%
				padding-left 5px;
				box-sizing border-box
				&:first-child {
					border-right: 1px solid #ECECEC
					padding-right: 5px;
				}
			}
		}
	}
	.btn-box {
		margin-top 15px;
		display flex
		justify-content center
		.btn {
			width: 120px;
		}
	}
}
</style>
